import { Component, OnInit, input } from '@angular/core';
import { Observable } from 'rxjs';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'ziro-animated-image',
  templateUrl: './animated-image.component.html',
  styleUrls: ['./animated-image.component.scss'],
  standalone: false,
})
export class AnimatedImageComponent implements OnInit {
  readonly lottiParams = input<AnimationOptions>();
  readonly animationStart$ = input(new Observable<void>());
  private _anim: any;

  ngOnInit(): void {
    this.animationStart$().subscribe(() => {
      this._anim.play();
    });
  }

  handleAnimation(anim: any): void {
    this._anim = anim;
  }
}
